<template>
  <section class="section" v-if="showMap">
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <h1 class="title">Mapas</h1>
        </div>
         <!-- <h3 style="color:#888888" class="subtitle">{{ getClientName() }}</h3>  -->
      </div>
      <div class="level-right">
        <div class="level-item">
          <b-field
            type="is-primary"
            label="Selecione o Dia"
            label-position="on-border"
          >
            <b-datepicker
              :date-formatter="dateConverter"
              v-model="selected_date"
              icon="calendar-day"
              ><button
                class="button is-primary"
                @click="
                  selected_date = new Date(new Date().setHours(0, 0, 0, 0))
                "
              >
                <span>Hoje</span>
              </button></b-datepicker
            >
          </b-field>
        </div>
      </div>
    </div>
    <br />
    <div id="boxContainer">
      <div id="topBox">
        <div class="optionsCards">
          <b-tooltip label="São aparelhos conectados à sua rede wifi.
            " type="is-info"
            >
            <b-button
            :class="[
              ap_connect ? ' outlined is-primary' : 'inverted outlined '
            ]"
            @click="setApConnect"
            :loading="saving_connect"
            >Conectados</b-button
            >
          </b-tooltip>

          <b-tooltip label="São aparelhos identificados nas proximidades de um Vagalume" type="is-info"
            >
            <b-button
            :class="[
              ap_sensor ? ' outlined is-primary' : 'inverted outlined '
            ]"
            @click="setApSensor"
            :loading="saving_device"
            >Detectados</b-button
            >
          </b-tooltip>

        </div>
        <div style="width: 100%; height: 610px; text-align:right; z-index:0;">

          <l-map
            v-for="(lat, index) in latlngs"
            v-if="currentFloor == index"
            :key="index"
            :zoom="zoom"
            :bounds="bounds"
            :options="{ mapOptions, zoomControl: false }"
            style="height: 100%; text-align:right; width: 100%; z-index:0;"
            @update:center="centerUpdate"
            @update:zoom="zoomUpdate"
          >
            <l-tile-layer :url="url" :attribution="attribution" />
            <l-control-zoom position="bottomright"></l-control-zoom>
            <l-marker
              v-for="client in withTooltip"
              v-if="allMarkers==1"
              :key="client.name"
              :lat-lng="client.val"
            >
              <l-popup :content="client.name" />
              <l-icon
                v-if="client.aglomeracao"
                icon-url="static/favicon_warn.png"
                :iconSize="[25, 25]"
              />
              <l-icon
                v-else-if="client.status == 'online'"
                icon-url="static/favicon.ico"
                :iconSize="[25, 25]"
              />
              <l-icon
                v-else
                icon-url="static/favicon_off.png"
                :iconSize="[25, 25]"
              />
            </l-marker>
            -->
            <!--
                        -->

            <LeafletHeatmap
              :lat-lng="lat"
              :gradient="gradients[0]"
              :max="max_index"
              :radius="radiusMap"
              :min-opacity="opacity + 1 * opacity_gain"
              :max-zoom="18"
              :blur="blur"
            ></LeafletHeatmap>

            <l-control class="custom-control" position="topleft">
              <p>
                <b>Pisos</b>
              </p>
              <p
                v-for="(floor, index) in floors"
                :key="index"
                e
                style="text-align: center"
                @click="floorNameF(index)"
              >
               <input type="radio" v-if="currentFloor == index" checked="true"> {{floor.name ? floor.name.replace(/_/g, " ") : floor.Name.replace(/_/g, " ")}} </input>
                <input
                  value=""
                  style="width:20px;height:5px !important;padding:1px; border-color:white; background-color:white;border:none;"
                  disabled
                />
              </p>
            </l-control>

            <l-control
              position="bottomleft"
              collapsed="true"
              class="custom-control-configs"
            >
              <div class="tooltip">
                <button id="buttonTooltip" @click="openTooltip">
                  <b>?</b>
                </button>
              </div>

              <p><b>Máximo:</b> {{ max_index }}</p>
              <!--p  @click="maxUp()">
                              Maximo +
                          </p>
                          <p  @click="maxDown()">
                              Maximo -
                          </p-->

              <input
                type="range"
                :id="max_index"
                v-model="max_index"
                min="5"
                max="200"
                class="range"
              />
              <div class="numberBar">
                <p id="number1">0</p>
                <p id="number2">{{number2}}</p>
                <p id="number3">{{number3}}</p>
                <p id="number4">{{number4}}</p>
                <p id="number5">{{max_index}}</p>
              </div>
              <div class="progress">
                <div class="progress-bar"></div>
              </div>
            </l-control>
            <l-control
              position="bottomleft"
              collapsed="true"
              class="tooltipMap"
              v-if="tooltip"
            >
              <p>Altera a intensidade das cores do mapa de acordo com o numero de dispositivos {{dinamicText}} pelo Vagalume. O valor selecionado determina a partir de qual quantidade o mapa ficara vermelho</p></l-control
            >
            <l-image-overlay :url="imgUrl" :bounds="bounds" />
          </l-map>

          <!--
                    <div class="columns is-desktop" v-if="onlineData" style="margin-top: 8px">


                      <div class="column is-2">
                        <div class="columns is-variable is-1 is-mobile is-tablet is-multiline">
                          <div class="column is-12-desktop is-6-mobile">
                            <box-stat :data="total_sensor" :title="total_sensor_title" linecolor="line-red"></box-stat>

                          </div>
                          <div class="column is-12-desktop is-6-mobile">
                            <box-stat :data="total_connect" :title="total_connect_title" linecolor="line-blue"></box-stat>
                          </div>
                        </div>
                      </div>
                    <div class="column is-10-desktop is-12-tablet">
                        <sensored-line :data="onlineData" :settings="settings" :segdata="segdata"></sensored-line>
                      </div>
                    </div>
              -->
        </div>
      </div>
      <div class="columns" id="bottonBox">
        <div class="column is-1 is-16-mobile">
          <b-field class="checkboxShowAllDay">
            <b-checkbox v-model="showAllDay">
              Dia Todo
            </b-checkbox>
          </b-field>
        </div>

        <div class="column is-11 is-16-mobile" v-if="!showAllDay" id="textHour">
          <b-slider
            v-model="targetHour"
            size="is-large"
            type="is- primary"
            :min="1"
            :max="24"
            :step="1"
            :tooltip="false"
          >
            <template
              v-for="val in [
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                20,
                21,
                22,
                23,
                24,
              ]"
            >
            <b-slider-tick v-if="val < 24" :value="val" :key="val"
                >{{ val }}:00</b-slider-tick
              >

             <b-slider-tick v-else :value="val" :key="val"
                >{{ val - 24 }}:00</b-slider-tick
              >
            </template>
          </b-slider>

        </div>
      </div>


    </div>

    <!-- JGFF: !MAPA -->
  </section>
</template>

<script>
import Webservices from "@/Webservices";
import { mapActions, mapGetters } from "vuex";
import store from "@/store";
import UserQuestion from "@/components/UserQuestion";
import L, { tooltip } from "leaflet";
import { latLng, latLngBounds, icon } from "leaflet";
import {
  LMap,
  LTileLayer,
  LMarker,
  LControl,
  LControlLayers,
  LControlAttribution,
  LImageOverlay,
  LIcon,
  LPopup,
  LControlZoom,
  LTooltip
} from "vue2-leaflet";
import LeafletHeatmap from "../../vue2-leaflet-heatmap";
//import LeafletHeatmap from './../heatmap/dist/Vue2LeafletHeatmap.common'
import SensoredLine from "@/components/charts/SensoredLine";
import BoxStat from "@/components/charts/BoxStat";

import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import axios from "axios";

import Vue from "vue";

var moment = require("moment");

const ws = new Webservices();
/**curl --location --request GET 'http://35.231.118.223:9090/report?client=boulevard_londrina_shopping&type=flow&period=day&datetime=2020-05-01T03:00:00Z' --header 'Authorization: Basic ZG06QGRtY2xpZW50Jg==' --header 'Origin: https://example.com' */

export default Vue.component("maps", {
  components: {
    datetime: Datetime,
    LeafletHeatmap,
    daySelected: "",
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPopup,
    LControl,
    LImageOverlay,
    LControlZoom,
    LTooltip,
    SensoredLine,
    BoxStat
  },
  data: () => ({
    dinamicText: "conectados",
    baseUrl: "https://portal.vagalumewifi.com.br",
    //baseUrl: "http://localhost:8080",
    debug_map: false,
    total_sensor: [0, 0, 0],
    total_connect: [0, 0, 0],
    total_sensor_title: "Dispositivos Detectados",
    total_connect_title: "Dispositivos Conectados",
    active_linecolor: "line-blue",
    ap_sensor: false,
    ap_connect: true,
    saving_device: false,
    saving_connect: false,
    radios: [],
    notifications: [],
    selected_date: new Date(),
    ph_datepicker: new Date(),
    targetHour: 0,
    targetHourTemp: 0,
    withTooltip: [],
    latlngs: [],
    allMarkers: 1,
    zoom: 18,
    imgUrl: "",
    currentFloor: 0,
    floors: [],
    floorName: "",
    //url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    //attribution:  '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    url: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png",
    attribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, &copy; <a href="https://carto.com/attribution">CARTO</a>',

    currentZoom: 18,
    currentCenter: latLng(47.41322, -1.219482),
    mapOptions: {
      zoomSnap: 0.1
    },
    showMap: true,
    bounds: latLngBounds(
      {
        lat: store.state.client.coordinates.North,
        lng: store.state.client.coordinates.West
      },
      {
        lat: store.state.client.coordinates.South,
        lng: store.state.client.coordinates.East
      }
    ),

    //!map
    tooltip: false,
    date: new Date(),
    segdata: { devices: [], sensored: [] },
    settings: { periodo: 24 },
    dataOnline: [],
    onlineData: [],
    maxSensoredInDay: 0,
    maxConnectInDay: 0,
    max_index: 15,
    max_index_gain: 5,
    max_index: 30,
    showAllDay: false,
    blur: 15,
    blur_gain: 5,
    opacity: 0.1,
    opacity_gain: 0.1,
    radiusMap: 35,
    radiusMap_gain: 5,
    gradients: [
      { 0.15: "blue", 0.4: "green", 1: "red" },
      { 0.15: "blue", 0.4: "green", 0.5: "red" },
      { 0.15: "blue", 0.4: "green", 0.5: "red" },
      { 0.15: "blue", 0.4: "green", 0.5: "red" }
    ]
  }),
  computed: {
    ...mapGetters([
      "ageRanges",
      "getID",
      "getClientID",
      "getControllerId",
      "getClients",
      "getToken",
      "getDailyFlow"
    ]),

    number2(){
      var output = Math.round(this.max_index*0.15)
      return output
    },


    number3(){
      var output = Math.round(this.max_index*0.6)
      return output
    },

    number4(){
      var output = Math.round(this.max_index*0.8)
      return output
    },

    daySelected_() {
      return this.daySelected;
    },
    onlineTotal() {
      var saida = [0, 0, 0];

      saida[2] = this.dataOnline.filter(el => typeof el === "object").length;

      var delta = 0;
      if (saida[2] > 0) delta = this.onlineData[23] - saida[2];
      document.dispatchEvent(
        new CustomEvent("deltaOk", {
          detail: delta
        })
      );

      try {
        saida[1] = this.onlineData[22] - delta;
        saida[0] = this.onlineData[21] - delta;
      } catch (exc) {
        saida[1] = 0;
        saida[0] = 0;
      }

      return saida;
    },

    /** TODO ==> Done
     * Entender como estas rotas sao atualizadas periodicamente
     * Alterar origem dos dados para rota da soonar no caso de devices
     * Dividir output de rota da soonar com total de devices associados num dia (dataByPeriod() <== importar de Dashboard)
     */
    dailyFlow() {
      if (this.debug_map) console.log("dailyFlow");
      return ws.getDailyFlow(
        store.state.client.idVagalox,
        "2020-05-15T03:00:00Z" /*, this.currentFloor*/
      );
      //return ws.getHourlyFlow(store.state.client.idVagalox, "2020-05-15T13:12:32"/*, this.currentFloor*/);
    },
    //widget total sensoriado
    segdataOnline() {
      var last = this.onlineData.length - 1;
      var saida = this.onlineData.slice(last - 3, last).map(el => el.online);
      if (this.debug_map) console.log(">>segdataOnline");
      if (this.debug_map) console.log(saida);
      if (this.debug_map) console.log(last);
      return saida;
    },
    //widget total conectado
    segdataDevices() {
      var last = this.onlineData.length - 1;
      var saida = this.onlineData.slice(last - 3, last).map(el => el.devices);
      if (this.debug_map) console.log(">>segdataDevices");
      if (this.debug_map) console.log(saida);

      return saida;
    }
  },

  async mounted() {
    if (await ws.checkAccessToken(this.getToken)) {
      this.logout();
      this.$router.push("/login");
    }
    //if(this.debug_map) console.log(this);
    this.selected_date = new Date();
    this.loadOnlineData();

    //TODO revisar tirar este loop
    if (this.idInterval) {
      clearInterval(this.idInterval);
    }
    this.targetHour = moment().hour();
    this.idInterval = setInterval(_ => {
      this.loadOnlineData();
    }, 30 * 60 * 1000); //30 min
    // }, 300000); //5 min
  },

  watch: {
    settings: {
      deep: true,
      handler(newValue) {
        this.loadOnlineData();
      }
    },
    showAllDay(newValue) {
      if (newValue == true) {
        this.targetHourTemp = 0;
        this.targetHour = 0;
      }
      else{
        this.targetHour = moment().hour();
      }

    },
    targetHour(value) {
      setTimeout(() => {
        if (this.targetHourTemp == 0) {
          this.save();
          this.targetHourTemp = 1;
          setTimeout(() => {
            this.targetHourTemp = 0;
          }, 500);
        }
      }, 1000);
    },
    selected_date() {
      this.targetHour = moment().hour();
      if (this.debug_map) console.log("selected_date", this.selected_date);
      this.ph_datepicker = new Date(this.selected_date);
      setTimeout(async () => {
        await this.save();
        this.getTotalSensorAtual();
      }, 50);
    },
    getControllerId(newValue) {
      if (!store.state.client.coordinates) {
        this.$router.push("/dashboard");
      } else {
        this.targetHour = moment().hour();
        this.showMap = false;
        let actual_targetHour = this.targetHour;
        this.targetHour = 99;
        setTimeout(() => {
          this.showMap = true;

          this.bounds = latLngBounds(
            {
              lat: store.state.client.coordinates.North,
              lng: store.state.client.coordinates.West
            },
            {
              lat: store.state.client.coordinates.South,
              lng: store.state.client.coordinates.East
            }
          );
          this.initialize();
          this.center = this.getClientCenter();
          this.currentFloor = 0;
          this.imgUrl =
            this.baseUrl +
            "/static/plant-info/" +
            store.state.client.radio_prefix.toLowerCase() +
            "/" +
            store.state.client.Floors[this.currentFloor].name +
            ".png";
          this.floorName = store.state.client.Floors[0].name;
          this.floors = store.state.client.Floors;
          ws.setToken(this.getToken);
          ws.getNotifications(store.state.client.radio_prefix)
            .then(response => {
              this.notifications = response.data;
            })
            .catch(err => {});
          ws.getRadiosByRadioPrefix(store.state.client.radio_prefix)
            .then(res => {
              this.radios = res.data;
              this.getApHeatMap();
              this.getTotalSensorAtual();
              this.targetHour = actual_targetHour;
            })
            .catch(err => {
              console.log(err);
            });
        }, 100);
      }
    }
  },
  beforeCreate() {
    if (!store.state.client.coordinates) {
      this.$router.push("/dashboard");
      location.reload();
    }
  },
  beforeDestroy() {
    if (this.idInterval) {
      if (this.debug_map) console.log("destroyed timer: ", this.idInterval);
      clearInterval(this.idInterval);
    }
  },
  created() {
    this.initialize();
    this.center = this.getClientCenter();
    this.currentFloor = 0;
    this.imgUrl =
      this.baseUrl +
      "/static/plant-info/" +
      store.state.client.radio_prefix.toLowerCase() +
      "/" +
      store.state.client.Floors[this.currentFloor].name +
      ".png";
    this.floorName = store.state.client.Floors[0].name;
    this.floors = store.state.client.Floors;
    ws.setToken(this.getToken);
    ws.getNotifications(store.state.client.radio_prefix)
      .then(response => {
        this.notifications = response.data;
      })
      .catch(err => {});
    ws.getRadiosByRadioPrefix(store.state.client.radio_prefix)
      .then(res => {
        this.radios = res.data;
        this.getApHeatMap();
        this.getTotalSensorAtual();
      })
      .catch(err => {
        console.log(err);
      });
    //this.floorName = "teste";
  },

  methods: {
    ...mapActions(["logout"]),
    getClientName() {
      return store.state.client.name;
    },
    openTooltip() {
      this.tooltip = !this.tooltip;
    },
    getApHeatMap() {
      const coordinates = store.state.client.coordinates;
      let floorAtual = this.floors[this.currentFloor];
      const width = floorAtual.Width;
      const height = floorAtual.Height;
      const heightC = coordinates.North - coordinates.South;
      const widthC = coordinates.East - coordinates.West;
      let listaAps2 = this.radios;

      var listaHeat = [];
      this.latlngs = [];
      this.withTooltip = [];
      var max_conn = 0;
      if (this.debug_map)
        console.log("selected_date pre: ", this.selected_date);
      var selected_date_zero = new Date(this.selected_date);
      selected_date_zero.setHours(0, 0, 0);
      if (this.debug_map)
        console.log("selected_date pos: ", this.selected_date);
      var newDate = new Date(
        selected_date_zero.getTime() + this.targetHour * 3600000
      );
      for (let ap of listaAps2) {
        if (ap.map && ap.historico) {
   
          var ap_stations = ap.total5ghz
            ? ap.total5ghz + ap.total2ghz
            : ap.totaEl2ghz
            ? ap.total2ghz
            : 0;
          max_conn = max_conn < ap_stations ? ap_stations : max_conn;
          //if(this.debug_map) console.log(ap_stations)
          const horaEscolhida = ap.historico.find(
            x =>
              x.date <
              (this.targetHour == 0 ? new Date().getTime() : newDate.getTime())
          );

          const on_off = horaEscolhida ? horaEscolhida.status : "online";
          var ap_map = ap.map;
          let apCord1 = (ap_map.y * heightC) / height;
          let apCord2 = (ap_map.x * widthC) / width;

          if (listaHeat[ap_map.floor] == undefined) {
            listaHeat[ap_map.floor] = [];
          }
          if (on_off == "online") {
            //if(this.debug_map) console.log(ap_stations)

            listaHeat[ap_map.floor].push([
              coordinates.North - apCord1,
              coordinates.West + apCord2,
              ap_stations
            ]);

            if (ap_map.relations) {
              for (let relation of ap_map.relations) {
                listaHeat[ap_map.floor].push([relation.lat, relation.lng, 0.0]);
              }
            }
          }
          if (ap_map.floor == this.currentFloor) {
            ap.aglomeracao = this.notifications.find(x => x.ip === ap.ip);
            if (!this.ap_sensor) {
              this.withTooltip.push({
                aglomeracao:
                  ap.aglomeracao && ap.aglomeracao.sensor_step_score >= 100
                    ? true
                    : false,
                status: on_off,
                val: latLng(
                  coordinates.North - apCord1,
                  coordinates.West + apCord2
                ),
                name:
                  "<b>Nome:</b> " +
                  (ap.name.split("_")[1]
                    ? ap.name.split("_")[1]
                    : ap.name.split("--")[1]) +
                  "<br><b>IP:</b> " +
                  ap.ip +
                  "<br><b>Conectados:</b> " +
                  parseInt(ap_stations) +
                  "<br><b> Aglomeração:</b> " +
                  (ap.aglomeracao && ap.aglomeracao.sensor_step_score >= 100
                    ? "Sim"
                    : "Não")
              });
            } else {
              this.withTooltip.push({
                aglomeracao:
                  ap.aglomeracao && ap.aglomeracao.sensor_step_score >= 100
                    ? true
                    : false,
                status: on_off,
                val: latLng(
                  coordinates.North - apCord1,
                  coordinates.West + apCord2
                ),
                name:
                  "<b>Nome:</b> " +
                  (ap.name.split("_")[1]
                    ? ap.name.split("_")[1]
                    : ap.name.split("--")[1]) +
                  "<br><b>IP:</b> " +
                  ap.ip +
                  "<br><b>Detectados:</b> " +
                  parseInt(ap_stations) +
                  "<br><b> Aglomeração:</b> " +
                  (ap.aglomeracao && ap.aglomeracao.sensor_step_score >= 100
                    ? "Sim"
                    : "Não")
              });
            }
          }
        }
      }
      if (this.debug_map) console.log("listaHeat");
      if (this.debug_map) console.log(listaHeat);
      //this.max_index = this.max_index >200 ? 200 : (parseInt((max_conn/5+1))*5) + 10
      this.latlngs = listaHeat;
    },
    markersOnlyOn() {
      this.allMarkers == 1 ? (this.allMarkers = 0) : (this.allMarkers = 1);
    },
    maxUp() {
      this.max_index = this.max_index + this.max_index_gain;
    },
    maxDown() {
      this.max_index =
        this.max_index < 5 ? 0 : this.max_index - this.max_index_gain;
    },
    radiusMapUp() {
      this.radiusMap = this.radiusMap + this.radiusMap_gain;
    },
    radiusMapDown() {
      this.radiusMap =
        this.radiusMap < 5 ? 0 : this.radiusMap - this.radiusMap_gain;
    },
    blurUp() {
      this.blur = this.blur >= 50 ? this.blur : this.blur + this.blur_gain;
    },
    blurDown() {
      this.blur = this.blur < 5 ? 0 : this.blur - this.blur_gain;
    },
    floorNameF(selected_floor) {
      if (selected_floor) this.currentFloor = selected_floor;
      this.imgUrl =
        this.baseUrl +
        "/static/plant-info/" +
        store.state.client.radio_prefix.toLowerCase() +
        "/" +
        store.state.client.Floors[this.currentFloor].name +
        ".png";
      this.getApHeatMap();
      //return "teste"
    },
    // formatDate(date){
    //   //var  = this.selected_date
    //   return date.getDate() + '/' + date.getMonth() + ' ' + date.getFullYear();
    // },
    initialize() {},
    //map
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    innerClick() {
      alert("Click!");
    },
    getClientCenter() {
      var lat =
        (store.state.client.coordinates.North +
          store.state.client.coordinates.South) /
        2;
      var lng =
        (store.state.client.coordinates.East +
          store.state.client.coordinates.West) /
        2;
      return lat, lng;
    },

    getFloors() {
      return store.state.client.Floors;
    },
    showAlert() {
      if (this.currentFloor == 0) {
        this.imgUrl = "";
        this.floorName = store.state.client.Floors[0].name;
        this.currentFloor = 1;
      } else {
        this.imgUrl = "";
        this.floorName = store.state.client.Floors[1].name;
        this.currentFloor = 0;
      }
    },
    filtrar() {
      this.isLoading = true;

      //this.loadHeatmap();
    },
    setApSensor() {
      this.ap_sensor = true;
      this.ap_connect = false;
      this.save();
      this.dinamicText = "detectados"
    },
    setApConnect() {
      this.ap_sensor = false;
      this.ap_connect = true;
      this.save();
      this.dinamicText = "conectados"
    },
    selectData() {
      if (this.debug_map) console.log(this.dates);

      this.dateSD = moment(this.dates[0]).format("yyyy-MM-DD");

      this.filtrar();
    },
    getTotalSensorAtual() {
      var selected_date_as_array = [
        this.selected_date.getDate(),
        this.selected_date.getMonth() + 1,
        this.selected_date.getFullYear()
      ];
      var newDate = new Date();
      var today_as_array = [
        newDate.getDate(),
        newDate.getMonth() + 1,
        newDate.getFullYear()
      ];
      /*newDate.setMinutes(0)
        var totalConectados = 0;
        for(let ap of this.radios){
          totalConectados +=  ap.total5ghz ? ap.total5ghz + ap.total2ghz  : ap.total2ghz ? ap.total2ghz  : 0;
        }*/

      if (this.debug_map)
        console.log(
          "today_as_array ",
          today_as_array,
          " ",
          selected_date_as_array
        );
      if (
        JSON.stringify(selected_date_as_array) == JSON.stringify(today_as_array)
      ) {
        ws.getLastSensored(store.state.client.idVagalox)
          .then(res => {

            if (this.debug_map) console.log("ws.getLastSensored");
            var data = res.data;
            if (!data[0]) {
              throw new Error("");
            } else {
              var total = data[0].Total_Stations;

              this.total_sensor = [0, 0, parseInt(total)];
              this.total_sensor_title = "Dispositivos Detectados";
            }
          })
          .catch(err => {
            this.total_sensor = [0, 0, 0];
            this.total_sensor_title = "Dispositivos Detectados - Falha";
            console.log(err);
          });
        ws.getTotalDevices(store.state.client.radio_prefix).then(res => {
          var data = res.data[0].totaldevices;
          this.total_connect = [0, 0, parseInt(data)];
          this.total_connect_title = "Dispositivos Conectados";
          this.active_linecolor = "line-blue";
        });
      } else {
        // ws.getDailyFlow(
        //   store.state.client.idVagalox.split('-').join('_'),
        //   this.selected_date, 32
        //   ).then(res => {
        //     if(this.debug_map) console.log("ws.getDailyFlow")
        //     var data = res.data

        //       var total = data.visits

        // }).catch(err=> {
        //     this.total_sensor = [0,0,0]
        //     this.total_sensor_title = "Total de Dispositivos Detectados - Falha"
        //     console.log(err)
        // });

        this.total_sensor = [0, 0, this.maxSensoredInDay];
        this.total_sensor_title = "Pico de Dispositivos Detectados";

        this.total_connect = [0, 0, this.maxConnectInDay];
        this.total_connect_title = "Pico de Dispositivos Conectados";
        this.active_linecolor = "";
      }
    },
    async save() {
      if(this.ap_sensor){
        this.saving_device = true
      }
       if(this.ap_connect){
        this.saving_connect = true
      }



      var selected_date_zero = new Date(this.selected_date);
      selected_date_zero.setHours(0, 0, 0);
      var newDate = new Date(
        selected_date_zero.getTime() + (this.targetHour - 3) * 3600000
      ).toISOString();
      if (this.debug_map)
        console.log(
          "save newDate:",
          newDate,
          " ",
          this.selected_date.getTime(),
          " ",
          this.targetHour,
          " ",
          this.selected_date
        );

      if (this.targetHour > 0) {
        if (this.ap_sensor) {
          ws.getRadiosSensor(
            store.state.client.radio_prefix,
            newDate
          )
            .then(res => {
              this.latlngs = [];
              var data = res.data;
              if (!data[0]) {
                alert("Não há dados para esse dia.");
              }
              var lista = [];
              for (let dataa of data) {
                lista[dataa.ap_id] = dataa.total;
              }
              for (let [index, radio] of this.radios.entries()) {
                this.radios[index].total5ghz = lista[radio.ip];
                this.radios[index].total2ghz = 0;
              }
              setTimeout(() => {
                this.floorNameF();
                this.saving_device = false
                this.saving_connect = false;
              }, 50);
            })
            .catch(err => {
              this.saving_device = false
              this.saving_connect = false;
              console.log(err);
            });
        } else {
          ws.getRadiosConnect(store.state.client.controller_id, newDate)
            .then(res => {
              var data = res.data;

              if (!data) {
                alert("Não há dados para esse dia.");
              }
              var lista = [];
              for (let dataa of data) {
                lista[dataa.ap_id] = dataa.total;
              }
              for (let [index, radio] of this.radios.entries()) {
                this.radios[index].total5ghz = lista[radio.ip];
                this.radios[index].total2ghz = 0;
              }
              this.latlngs = [];
              setTimeout(() => {
                this.floorNameF();
                this.saving_connect = false
                this.saving_device = false
              }, 50);
            })
            .catch(err => {
              this.saving_device = false
              this.saving_connect = false;
              console.log(err);
            });
        }
      } else {
        if (this.ap_sensor) {
          ws.getRadiosSensortDay(
           store.state.client.radio_prefix,
            newDate
          )
            .then(res => {
              this.latlngs = [];
              var data = res.data;
              if (!data[0]) {
                alert("Não há dados para esse dia.");
              }
              var lista = [];
              for (let dataa of data) {
                lista[dataa.ap_id] = dataa.total;
              }
              for (let [index, radio] of this.radios.entries()) {
                this.radios[index].total5ghz = lista[radio.ip];
                this.radios[index].total2ghz = 0;
              }
              setTimeout(() => {
                this.floorNameF();
                this.saving_device = false
                this.saving_connect = false;
              }, 50);
            })
            .catch(err => {
              this.saving_device = false
              this.saving_connect = false;
              console.log(err);
            });
        } else {
          ws.getRadiosConnectDay(store.state.client.controller_id, newDate)
            .then(res => {
              this.latlngs = [];
              var data = res.data;
              if (!data[0]) {
                alert("Não há dados para esse dia.");
              }
              var lista = [];
              for (let dataa of data) {
                lista[dataa.ap_id] = dataa.total;
              }
              for (let [index, radio] of this.radios.entries()) {
                this.radios[index].total5ghz = lista[radio.ip];
                this.radios[index].total2ghz = 0;
              }
              setTimeout(() => {
                this.floorNameF();
                this.saving_device = false
                this.saving_connect = false;
              }, 50);
            })
            .catch(err => {
              this.saving_device = false
              this.saving_connect = false;
              console.log(err);
            });
        }
      }
      var resposta = await this.loadOnlineData();
      return 1;
    },
    dateConverter(date) {
      return date.toLocaleString("pt-BR", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        timeZone: "UTC"
      });
    },
    loadHeatmap() {
      var startDate = this.dateSD;
    },
    async loadOnlineData() {
      var dateED = this.selected_date
        ? moment(this.selected_date).format()
        : moment().format();
      if (this.debug_map) console.log("ED: " + dateED);
      var thisIntern = this;
      
      return await new Promise(function(resolve, reject) {
        //TODO avaliar se é radio_prefix ou clientname e por que teresina responde com os dois...
        //essa funcao esta sendo chamado a cada troca do sensored/conectado e periodicamente
        ws.getSensoredGraph(store.state.client.controller_id, dateED).then(
          response => {
            thisIntern.maxSensoredInDay = 0;
            thisIntern.maxConnectInDay = 0;
            if (thisIntern.debug_map) console.log(">>getSensoredGraph");
            if (thisIntern.debug_map) console.log(response.data);

            thisIntern.onlineData = response.data.map(el => {
              if (parseInt(el.totaldevices) >= thisIntern.maxSensoredInDay) {
                thisIntern.maxSensoredInDay = parseInt(el.totaldevices);
              }
              if (parseInt(el.totalonline) >= thisIntern.maxConnectInDay) {
                thisIntern.maxConnectInDay = parseInt(el.totalonline);
              }
              return {
                datetime: el.datetime,
                sensored: parseInt(el.totaldevices),
                devices: parseInt(el.totalonline)
              };
            });
            resolve(1);
          }
        );
      });
    }
  }
});
</script>

<style scoped>
.custom-control {
  text-align: left;
  background: #fff;
  width: 100px;
  padding: 0 0.5em;
  border: 1px solid #aaa;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.custom-control-configs {
  text-align: left;
  background: #fff;
  width: 300px;
  padding: 0.5em 0.5em;
  border: 1px solid #aaa;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.leaflet-marker-icon,
.leaflet-marker-shadow {
  height: 30px !important;
}

.capitalize {
  text-transform: capitalize !important;
}

#topBox {
  margin-top: -45px;
}

.checkboxShowAllDay {
  font-family: sans-serif;
  font-size: 17px;
  padding-top: 12px;
}

.optionsCards {
  padding-bottom: 8px;
}

#bottonBox {
  padding-top: 10px;
}

.tooltipMap {
  text-align: justify;
  font-family: sans-serif;
  font-size: 12px;
  background: #fff;
  width: 300px;
  padding: 0.2em 0.2em;
  border: 1px solid #aaa;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);

}

#buttonTooltip {
  color: #f56618;
  font-weight: bold;
  font-size: 15px;
}

.progress{
  height: 12px;
  background-image: linear-gradient(to right, blue 20%, cyan 35%, lime 55%, yellow 70%, red 85% );
  position: relative;
}
.range{
  width: 285px;
  height: 10px;
}

.numberBar{
  display: flex;
  flex-direction: row;
  position:relative;
}

#number1{
  position:relative;
  left:0%;
  margin-bottom: -3px
}

#number2{
  position:relative;
  left:16%;
  margin-bottom: -3px
}

#number3{
  position:relative;
  left:36%;
  margin-bottom: -3px
}

#number4{
  position:relative;
  left:52%;
  margin-bottom: -3px
}

#number5{
  position:relative;
  left:67%;
  margin-bottom: -3px
}

</style>



// WEBPACK FOOTER //
// src/components/Maps.vue